import { createReducer } from 'redux-act';
import * as action from '../actions/user.actions';
import user from '../../schemas/user.schema';
import { jwtDecode } from 'jwt-decode';

export const initialState = {
  model: user.parse({}),
  facilities: [],
  selectedPatientExternalId: null,
  fhirPatient: null,
  isUserAmbAdmin: false,
  preferredFacility: null,
};

const userReducer = createReducer(
  {
    [action.fetchCurrentUserSuccess]: (state, payload) => {
      return {
        ...state,
        model: user.parse(payload),
      };
    },
    [action.setUserFacilities]: state => {
      return {
        ...state,
        facilities: state.model.facilities || [],
        preferredFacility: state.model.preferredFacility || null,
      };
    },
    [action.updatePreferredFacility]: (state, payload) => {
      return {
        ...state,
        preferredFacility: payload,
      };
    },
    [action.selectPatientExternalId]: (state, payload) => ({
      ...state,
      selectedPatientExternalId: payload,
    }),
    [action.fetchAccessTokenSuccessfully]: (state, payload) => {
      const {
        fhir_patient: fhirPatient,
        realm_access: { roles: realmRoles },
      } = jwtDecode(payload);
      const isUserAmbAdmin = realmRoles.includes('amb_admin');

      return {
        ...state,
        fhirPatient,
        isUserAmbAdmin,
      };
    },
  },
  initialState,
);

export default userReducer;
